var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.$t("plain-text-note.text"))+": ")]),_c('span',[_vm._v(_vm._s(_vm.note.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }